import { Stack, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  isActive?: boolean;
  border?: 'gold' | 'normal';
  sx?: SxProps<Theme>;
}
export const CircleGoldBorder: FC<Props> = ({ children, isActive, border = 'gold', sx }) => {
  return (
    <Stack
      sx={{
        height: 44,
        width: 44,
        borderRadius: '50%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all .5s',
        ...(border === 'gold' && { backgroundImage: ({ palette }) => palette.customColors.goldBorder }),
        zIndex: -2,
        '&::after': {
          content: "''",
          position: 'absolute',
          height: '94%',
          width: '94%',
          borderRadius: '50%',
          ...(border === 'normal' && { border: '1.25px solid' }),
          backgroundColor: ({ palette }) => (isActive ? palette.text.primary : palette.background.paper),
          zIndex: -1,
        },
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
};
